import logo from './logo.svg';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import HomePage from './components/HomePage';
import InfoPage from './components/InfoPage';
import Admissions from './components/Admissions';
import Images from './components/Images';
import Announcements from './components/Announcements';

function App() {
  return (
    <BrowserRouter>
    <Header/>
      <div>
         <Routes>
            <Route exact path="/" element={<HomePage/>} />
            <Route path="/info" element={<InfoPage/>}/>
            <Route path="/admissions" element={<Admissions/>}/>
            <Route path="/images" element={<Images/>} />
            <Route path="/announcements" element={<Announcements />} />
         </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
